import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {HomeComponent} from '../app/components/home/home.component';
import {ResultadosBuscaComponent} from '../app/components/resultados-busca/resultados-busca.component';
import {MeuPainelComponent} from '../app/components/meu-painel/meu-painel.component';
import {CadastroPromptComponent} from '../app/components/cadastro-prompt/cadastro-prompt.component';
import {CategoriaComponent} from '../app/components/categoria/categoria.component';
import {UsuariosComponent} from '../app/components/usuarios/usuarios.component';
import {GruposComponent} from '../app/components/grupos/grupos.component';
import {PerfilComponent} from '../app/components/perfil/perfil.component';
import {AuthGuard} from '../app/auth.guard';
import {EditarPromptComponent} from '../app/components/editar-prompt/editar-prompt.component';
import {NotFoundComponent} from '../app/components/not-found/not-found.component';
import {TelaPromptComponent} from '../app/components/tela-prompt/tela-prompt.component';
import {PromptDatabaseComponent} from '../app/components/prompt-database/prompt-database.component';
import {ManualPromptComponent} from '../app/components/manual-prompt/manual-prompt.component';
import {ProfileUpdateModalComponent} from '../app/components/profile-update-modal/profile-update-modal.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'resultados-busca',
    component: ResultadosBuscaComponent, canActivate: [AuthGuard]
  },
  // { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: 'cadastro-prompt',
    component: CadastroPromptComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastrar-categoria',
    component: CategoriaComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastrar-grupo',
    component: GruposComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastrar-usuario',
    component: UsuariosComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'prompt',
    component: PromptDatabaseComponent,
    canActivate: [AuthGuard],
  },
  { path: 'painel', component: MeuPainelComponent, canActivate: [AuthGuard] },
  { path: 'perfil', component: PerfilComponent, canActivate: [AuthGuard] },
  {
    path: 'editar-prompt/:id',
    component: EditarPromptComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tela-prompt/:id',
    component: TelaPromptComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'manual-prompt',
    component: ManualPromptComponent,
  },
  {
    path: 'profile-update-modal',
    component: ProfileUpdateModalComponent,
    canActivate: [AuthGuard],
  },

  { path: '**', component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
